export const INSTAGRAM_QUEUE = [
    { id: "all", label: "All Posts", color: "text-zinc-300" },
    { id: "needs_work", label: "Needs Work", color: "text-amber-300" },
    { id: "ready_to_post", label: "Ready to Post", color: "text-sky-300" },
    { id: "posted_on_website", label: "Posted on Website", color: "text-emerald-400" },
    { id: "already_on_website", label: "Already on Website", color: "text-teal-300" },
    { id: "skipped", label: "Not a Job/Skipped", color: "text-zinc-400" },
];

export const queueMeta = id => INSTAGRAM_QUEUE.find(item => item.id === id) || INSTAGRAM_QUEUE[1];
export const isHandled = draft => ["already_on_website", "skipped"].includes(draft.queue_status);